export function countdown(ts, local, now) {
  const target = ts ? new Date(ts) : new Date(local);
  const diff = target - now;
  if (Number.isNaN(diff)) return null;
  if (diff <= 0) return "now";
  const m = Math.floor(diff / 60000);
  const d = Math.floor(m / 1440);
  const h = Math.floor((m % 1440) / 60);
  const mm = m % 60;
  if (d > 0) return `in ${d}d ${h}h`;
  if (h > 0) return `in ${h}h ${mm}m`;
  return `in ${mm}m`;
}

export function fmtTime(local) {
  if (!local) return "";
  const [h, m] = local.slice(11, 16).split(":").map(Number);
  const ampm = h >= 12 ? "PM" : "AM";
  const hh = h % 12 || 12;
  return `${hh}:${String(m).padStart(2, "0")} ${ampm}`;
}

export function isDone(item, now) {
  const t = item.end_ts || item.ts;
  if (t) return new Date(t) < now;
  const end = item.end_local || item.local;
  return new Date(end) < now;
}

export function mapsHref(q) {
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(q)}`;
}

export function gapMinutes(prev, next) {
  const a = prev.end_ts || prev.ts;
  const b = next.ts;
  if (!a || !b) return null;
  const mins = Math.round((new Date(b) - new Date(a)) / 60000);
  return mins > 0 ? mins : null;
}
